import React, {useState} from 'react';
import PropTypes from 'prop-types';

function SelectField({
     id,
     label,
     defaultValue,
     allowEmpty,
     required,
     size,
     options,
     onChange,
}) {
    const [fieldId] = useState(id ? id : 'selectfield-' + Math.floor(Math.random() * 99999));
    const dispatchEvent = (event) => {
        onChange && onChange(event);
    };

    const entryClasses = ['form__entry'];
    if (required) {
        entryClasses.push('form__entry--required');
    }
    if (size) {
        entryClasses.push('form__entry--size-' + size);
    }

    return (
        <div className={entryClasses.join(' ')}>
            <div className='form__label'>
                <label htmlFor={fieldId}>
                        <span className='form__label__text'>
                            {label}
                        </span>
                </label>
            </div>
            <div className='form__field '>
                <select
                    id={fieldId}
                    name={fieldId}
                    className='form__select'
                    defaultValue={defaultValue}
                    onChange={dispatchEvent}
                    required={required}
                >
                    {allowEmpty && (
                        <option></option>
                    )}
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>{option.label}</option>
                    ))}
                </select>
            </div>
        </div>
    );
}

SelectField.propTypes = {
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    id: PropTypes.string,
    defaultValue: PropTypes.any,
    allowEmpty: PropTypes.bool,
    size: PropTypes.string,
    required: PropTypes.bool,
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.any,
        label: PropTypes.any
    })).isRequired,
};

export default SelectField;
